/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskCustomerNotificationsType from '@jira/spa-apps__project-settings-service-desk-customer-notifications/src/ExportedDefault.tsx';
import { HelpCenterSettingsRedirect } from '@jira/servicedesk__customer-service-common/src/HelpCenterSettingsRedirect.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type {
	Location,
	Query,
	Route,
	Match,
	HistoryAction,
} from '@atlassian/react-resource-router';

export const LazyProjectSettingsServiceDeskCustomerNotifications: LazyComponent<{
	(props: {
		location: Location;
		query: Query;
		route: Route;
		match: Match;
		action: HistoryAction;
	}): React.JSX.Element;
	displayName: string;
}> = lazyForPaint<typeof ProjectSettingsServiceDeskCustomerNotificationsType>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-customer-notifications", jiraSpaEntry: "async-project-settings-service-desk-customer-notifications" */ '@jira/spa-apps__project-settings-service-desk-customer-notifications/src/ExportedDefault.tsx'
		),
);

const AsyncProjectSettingsServiceDeskCustomerNotifications = (): React.JSX.Element => (
	<HelpCenterSettingsRedirect page="customer-notifications">
		<LazyPage
			Page={LazyProjectSettingsServiceDeskCustomerNotifications}
			pageId="project-settings-customer-notifications"
			shouldShowSpinner
		/>
	</HelpCenterSettingsRedirect>
);

export default AsyncProjectSettingsServiceDeskCustomerNotifications;
